var _circle, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 164"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 15,
    cy: 14.7766,
    r: 14.5,
    fill: "#FF9901",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1212_2853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 6.5,
    y: 5.27661,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1212_2853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1212_2853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box_2",
    x: 7,
    y: 7.27661,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1212_2853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stars_2",
    d: "M12.3333 19.2765L14.9999 17.2432L17.6666 19.2765L16.6666 15.9765L19.3333 14.0765H16.0666L14.9999 10.6099L13.9333 14.0765H10.6666L13.3333 15.9765L12.3333 19.2765ZM14.9999 21.9432C14.0777 21.9432 13.211 21.7682 12.3999 21.4182C11.5888 21.0682 10.8833 20.5932 10.2833 19.9932C9.68325 19.3932 9.20825 18.6876 8.85825 17.8765C8.50825 17.0654 8.33325 16.1988 8.33325 15.2765C8.33325 14.3543 8.50825 13.4876 8.85825 12.6765C9.20825 11.8654 9.68325 11.1599 10.2833 10.5599C10.8833 9.95986 11.5888 9.48486 12.3999 9.13486C13.211 8.78486 14.0777 8.60986 14.9999 8.60986C15.9221 8.60986 16.7888 8.78486 17.5999 9.13486C18.411 9.48486 19.1166 9.95986 19.7166 10.5599C20.3166 11.1599 20.7916 11.8654 21.1416 12.6765C21.4916 13.4876 21.6666 14.3543 21.6666 15.2765C21.6666 16.1988 21.4916 17.0654 21.1416 17.8765C20.7916 18.6876 20.3166 19.3932 19.7166 19.9932C19.1166 20.5932 18.411 21.0682 17.5999 21.4182C16.7888 21.7682 15.9221 21.9432 14.9999 21.9432ZM14.9999 20.6099C16.4888 20.6099 17.7499 20.0932 18.7833 19.0599C19.8166 18.0265 20.3333 16.7654 20.3333 15.2765C20.3333 13.7876 19.8166 12.5265 18.7833 11.4932C17.7499 10.4599 16.4888 9.9432 14.9999 9.9432C13.511 9.9432 12.2499 10.4599 11.2166 11.4932C10.1833 12.5265 9.66659 13.7876 9.66659 15.2765C9.66659 16.7654 10.1833 18.0265 11.2166 19.0599C12.2499 20.0932 13.511 20.6099 14.9999 20.6099Z",
    fill: "#FF9901"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.c39c30ebc76fe316b5c848bb1fd953c4.svg";
export { ForwardRef as ReactComponent };